import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/nplogo.png'


const _withScopeId = n => (_pushScopeId("data-v-1799ce7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mt-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row header-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "300"
    })
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center page-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "404"),
  /*#__PURE__*/_createElementVNode("p", null, "Sidan du försökte nå fanns inte."),
  /*#__PURE__*/_createElementVNode("p", null, "Vi har skickat en rapport till administratören.")
], -1))
const _hoisted_5 = { class: "col-md-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Tillbaka till förstasidan")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}